import { duration as r } from "@mui/material/styles/createTransitions";
const e = {
  duration: {
    shortest: r.shortest,
    shorter: r.shorter,
    short: r.short,
    standard: r.standard,
    complex: r.complex,
    enteringScreen: 150,
    leavingScreen: 120
  }
}, o = {
  duration: {
    shortest: 0,
    shorter: 0,
    short: 0,
    standard: 0,
    complex: 0,
    enteringScreen: 0,
    leavingScreen: 0
  }
};
export {
  o as transitionsNone,
  e as transitionsNormal
};
//# sourceMappingURL=transitions.js.map
